import * as Curry from "./curry.js";
import * as Caml_builtin_exceptions from "./caml_builtin_exceptions.js";

function $caret(prim, prim$1) {
  return prim + prim$1;
}

var stdout =
/* record */
[
/* buffer */
"",
/* output */
function (param, s) {
  var v = s.length - 1 | 0;

  if (typeof process !== "undefined" && process.stdout && process.stdout.write) {
    return process.stdout.write(s);
  } else if (s[v] === "\n") {
    console.log(s.slice(0, v));
    return (
      /* () */
      0
    );
  } else {
    console.log(s);
    return (
      /* () */
      0
    );
  }
}];
var stderr =
/* record */
[
/* buffer */
"",
/* output */
function (param, s) {
  var v = s.length - 1 | 0;

  if (s[v] === "\n") {
    console.log(s.slice(0, v));
    return (
      /* () */
      0
    );
  } else {
    console.log(s);
    return (
      /* () */
      0
    );
  }
}];

function caml_ml_open_descriptor_in(i) {
  throw [Caml_builtin_exceptions.failure, "caml_ml_open_descriptor_in not implemented"];
}

function caml_ml_open_descriptor_out(i) {
  throw [Caml_builtin_exceptions.failure, "caml_ml_open_descriptor_out not implemented"];
}

function caml_ml_flush(oc) {
  if (oc[
  /* buffer */
  0] !== "") {
    Curry._2(oc[
    /* output */
    1], oc, oc[
    /* buffer */
    0]);

    oc[
    /* buffer */
    0] = "";
    return (
      /* () */
      0
    );
  } else {
    return 0;
  }
}

var node_std_output = function node_std_output(s) {
  return typeof process !== "undefined" && process.stdout && (process.stdout.write(s), true);
};

function caml_ml_output(oc, str, offset, len) {
  var str$1 = offset === 0 && len === str.length ? str : str.slice(offset, len);

  if (typeof process !== "undefined" && process.stdout && process.stdout.write && oc === stdout) {
    return process.stdout.write(str$1);
  } else {
    var id = str$1.lastIndexOf("\n");

    if (id < 0) {
      oc[
      /* buffer */
      0] = oc[
      /* buffer */
      0] + str$1;
      return (
        /* () */
        0
      );
    } else {
      oc[
      /* buffer */
      0] = oc[
      /* buffer */
      0] + str$1.slice(0, id + 1 | 0);
      caml_ml_flush(oc);
      oc[
      /* buffer */
      0] = oc[
      /* buffer */
      0] + str$1.slice(id + 1 | 0);
      return (
        /* () */
        0
      );
    }
  }
}

function caml_ml_output_char(oc, $$char) {
  return caml_ml_output(oc, String.fromCharCode($$char), 0, 1);
}

function caml_ml_input(ic, bytes, offset, len) {
  throw [Caml_builtin_exceptions.failure, "caml_ml_input ic not implemented"];
}

function caml_ml_input_char(ic) {
  throw [Caml_builtin_exceptions.failure, "caml_ml_input_char not implemnted"];
}

function caml_ml_out_channels_list(param) {
  return (
    /* :: */
    [stdout,
    /* :: */
    [stderr,
    /* [] */
    0]]
  );
}

var stdin = undefined;
export { $caret, stdin, stdout, stderr, caml_ml_open_descriptor_in, caml_ml_open_descriptor_out, caml_ml_flush, node_std_output, caml_ml_output, caml_ml_output_char, caml_ml_input, caml_ml_input_char, caml_ml_out_channels_list };
/* node_std_output Not a pure module */